import { http } from '@/system/http.js';

export default {
    state: {
        templates: [],
        templatesLoaded: false,
        templatesLoading: false,
    },

    mutations: {
        setTemplates(state, templates) {
            state.templates = templates;
        },

        setTemplatesLoaded(state, templatesLoaded = true) {
            state.templatesLoaded = templatesLoaded;
        },

        setTemplatesLoading(state, templatesLoading = true) {
            state.templatesLoading = templatesLoading;
        },
    },

    getters: {
        templates: (state) => {
            return state.templates.filter(template => template.active) || [];
        },

        getTemplatesByType: (state, getters) => (type) => {
            return getters.templates.filter(t => t.type === type);
        },

        getTagReplacementsForClient: (state, getters, rootState, rootGetters) => (client) => {
            // Translation string
            let journalTemplateTagSettings = 'tags.journal_template_feed_tags.';

            /*
              These are the global tags available on all clients for all users. This array of
              objects contains both the old style tag ([name]) and new style tag (@name), this
              is so that each style is backwards compatible. But this array can be used to
              convert both style of tags to their values.

              Some newer tags will not have the oldStyleTag prop, this is because they
              were added after the new style tagging system was introduced.
             */
            return [{
                tag: trans('tags.first_name'),
                newStyleTag: trans(journalTemplateTagSettings + 'first_name.tag'),
                value: client.name.split(' ')[0],
            }, {
                tag: trans('tags.full_name'),
                newStyleTag: trans(journalTemplateTagSettings + 'full_name.tag'),
                value: client.name,
            }, {
                tag: trans('tags.your_name'),
                newStyleTag: trans(journalTemplateTagSettings + 'your_name.tag'),
                value: rootState.auth.user.realname,
            }, {
                tag: trans('tags.notes'),
                newStyleTag: trans(journalTemplateTagSettings + 'client_notes.tag'),
                value: client.notes,
            }, {
                tag: trans('tags.dob'),
                newStyleTag: trans(journalTemplateTagSettings + 'client_dob.tag'),
                value: client.dob && moment(client.dob).isValid() ? moment(client.dob).locale(moment_locale).format('L') : '',
            }, {
                tag: trans('tags.cpr'),
                newStyleTag: trans(journalTemplateTagSettings + 'social_security_number.tag'),
                value: client.cpr,
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'current_date_short.tag'),
                value: moment().locale(moment_locale).format('L'),
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'current_date_long.tag'),
                value: moment().locale(moment_locale).format(getLongDateFormat()),
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'current_weekday.tag'),
                value: moment().locale(moment_locale).format('dddd'),
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'user_email.tag'),
                value: rootState.auth.user.email,
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'client_email.tag'),
                value: client.email,
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'client_phone.tag'),
                value: client.phone,
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'client_address.tag'),
                value: [client.address, client.address_line_2].filter(ad => !isEmpty(ad)).join(', '),
            }, {
                newStyleTag: trans(journalTemplateTagSettings + 'client_country.tag'),
                value: client.country,
            }];
        },

        getReplaceableTag: () => (tagName) => {
            console.log(tagName)
        },
    },

    actions: {
        loadTemplates({ state, dispatch }) {
            if (state.templatesLoaded || state.templatesLoading) return;

            dispatch('forceLoadTemplates');
        },

        forceLoadTemplates({ state, commit }) {
            http.get('/app/document-templates')
                .then(({ data }) => {
                    commit('setTemplates', data);
                    commit('setTemplatesLoaded', true);
                })
                .catch(({ error }) => {
                    commit('setTemplates', []);
                    commit('setTemplatesLoaded', false);
                    console.error('Could not load journal templates', error);
                })
                .finally(() => {
                    commit('setTemplatesLoading', false);
                });
        },
    }
}